import { stat } from "fs";

const state = {
	dateFrom: "",
	loader: false,
	dateTo: "",
	quickReports: "",
	selectCategory: "",
	selectSalesView: "",
	selectLocation: "",
	locBasics: "",
	catBasics: "",
	AnalyticsData: {},
	GraphData: {},
	// LocSelected: [],
	basicsRouteMap: {
		country: "state",
		state: "region",
		region: "subregion",
		subregion: "store",
		store: "department",
		department: "category",
		category: "subcategory",
		subcategory: "product"
	},
	momHeadings: [],
	isOutletClickedFromTable: false,
	graphVisibility: false,
	salesView: '',
	rerender: '',
};

const mutations = {
	setLoader: (state, payload) => {
		state.loader = payload;
	},
	setGraphReRenderStatus: (state, payload) => {
		state.rerender = payload;
	},
	setGraphVisibility: (state, payload) => {
		state.graphVisibility = payload;
	},
	setSalesView: (state, payload) => {
		state.salesView = payload;
	},
	setDateFrom: (state, payload) => {
		state.dateFrom = payload;
	},
	setDateTo: (state, payload) => {
		state.dateTo = payload;
	},
	setQuickReports: (state, payload) => {
		state.quickReports = payload;
	},
	setSelectCategory: (state, payload) => {
		state.selectCategory = payload;
	},
	SET_MOM_HEADINGS: (state, payload) => {
		state.momHeadings = payload;
	},
	IS_OUTLET_CLIKED_FROM_TABLE: (state, payload) => {
		state.isOutletClickedFromTable = payload;
	},
	// setSelectOrderType: (state, payload) => {
	// 	state.selectOrderType = payload;
	// },
	setselectSalesView: (state, payload) => {
		state.selectSalesView = payload;
	},
	setLocBasis: (state, payload) => {
		state.locBasics = payload;
	},
	setCatBasics: (state, payload) => {
		state.catBasics = payload;
	},
	setSelectLocation: (state, payload) => {
		state.selectLocation = payload;
	},
	setAnalyticsData: (state, payload) => {
		state.AnalyticsData = payload;
	},
	// setLocSelected: (state, payload) => {
	// 	state.LocSelected = payload;
	// },
	setGraphData: (state, payload) => {
		state.GraphData = payload;
	}
};

const getters = {
	getLoader: state => state.loader,
	getGraphRerenderStatus: state => state.rerender,
	getGraphVisibility: state => state.graphVisibility,
	getSalesView: state => state.salesView,
	getDateFrom: state => state.dateFrom,
	getDateTo: state => state.dateTo,
	getQuickReports: state => state.quickReports,
	getSelectCategory: state => state.selectCategory,
	getSelectOrderType: state => state.selectOrderType,
	getselectSalesView: state => state.selectSalesView,
	getSelectLocation: state => state.selectLocation,
	getAnalyticsData: state => state.AnalyticsData,
	// getLocSelected: state => state.LocSelected,
	getGraphData: state => state.GraphData,
	getLocBasics: state => state.locBasics,
	getCatBasics: state => state.catBasics,
	getMomHeadings: state => state.momHeadings,
	getIsOutletClickedFromTable: state => state.isOutletClickedFromTable
};

export default {
	state,
	mutations,
	getters
};
